import { ClientAuth } from "./kinds.js";
/**
 * creates an EventTemplate for an AUTH event to be signed.
 */ export function makeAuthEvent(relayURL, challenge) {
  return {
    kind: ClientAuth,
    created_at: Math.floor(Date.now() / 1000),
    tags: [
      [
        'relay',
        relayURL
      ],
      [
        'challenge',
        challenge
      ]
    ],
    content: ''
  };
}
//# sourceMappingURL=nip42.js.map